<template>
  <div class="landmarkView">
		
	<div>
		<el-carousel loop indicator-position="none" arrow="never"
		 @change="changetab" height="376px" ref="img" >
			<el-carousel-item v-for="(item,index) in list" :key="index">
				<el-image 
				 fit='cover'
				  class="imgcenter"
				  @click="nav(item)"
				  :src="getFileAccessHttpUrl(item.breviaryMap)"
				  :title="item.title"
				></el-image>
			</el-carousel-item>
		</el-carousel>
	</div>
	
	<div class="lr_img"> 
	    <el-image fit='cover' class="imgcon" style="transform: rotate(180deg);" :src="require('../assets/newimg/rightimg@2x.png')" alt="" @click="prevbtn"></el-image>
		<!-- <img class="imgcon" src="../assets/newimg/leftimg@2x.png" alt="" @click="prevbtn"/> -->
		<el-image fit='cover' class="imgcon" :src="require('../assets/newimg/rightimg@2x.png')" alt="" @click="nextbtn"></el-image>
	</div>
	
	<div class="info_con">
		<div class="title">{{ list[signindex]?list[signindex].title.substring(0,24):''}}</div>
		<div class="describe">{{list[signindex]?gethypertext(list[signindex].content):''}}</div>
		<div class="time">{{list[signindex]?list[signindex].createTime:''}}</div>
		
		<div class="navcon">
			<div :class="index == signindex?'navsignle_cur':'navsignle'" v-for="(item,index) in list" :key="index"></div>
		</div>
	</div>
	
  </div>
</template>

<script>

export default {
  name: "LandmarkView",
 
  data() {
    return {
		  signindex: 0,
		  list: [],
	  
    };
  },
  mounted() {
	this.getnewsList()
  },
  created() {

  },

  methods: {
	prevbtn(){
		this.$refs.img.prev()
	},
	
	nextbtn(){
		this.$refs.img.next()
	},
	
    loginSelectOk() {
        this.$emit("swiperFun", {});
    },
	
    init() {
		  var that = this;
		  this.httpGet("web/thpWebCarousel/list", { type: 1 }).then(res => {
				that.list = res.result;
		  });
    },
	
	changetab(e){
		// console.log(e)
		this.signindex = e
	},
	
	//过滤富文本
	gethypertext(str){
		if(str == null){
			return "";
		}
		var str = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "").replace(/&rdquo;/gi, "")
		              .replace(/&ldquo;/gi, "").replace(/\n/gi, "").replace(/&hellip;/gi, "").replace(/&mdash;/gi, "");
		str = str.substring(0,50);
		return str;
	},
	
	getnewsList() {//web/info/list
		   var that = this;
		   this.httpGet("web/info/listImg", {
				 infoType: "6",
				 pageNo: 1,
				 pageSize: 4,
		   }).then((res) => {
				 that.list = res.result.records;
		   });
	},
	
    nav(item) {
		this.$router.push({
			  path: "/newscenterdetail",
			  query: { id: item.id },
		});
        // window.open(link);
    }
	
	
  }
};
</script>

<style scoped lang="scss">

.landmarkView,.imgcente{
  width: 500px;
  height: 376px;
}
.imgcente{
	cursor: pointer;
}
::-webkit-scrollbar {
	width: 0 !important;
}
::-webkit-scrollbar {
	width: 0 !important;height: 0;
}
		
.lr_img{
	cursor: pointer;
	margin-left: 500px;
	margin-top: -51px;
	width: 101px;
	height: 50px;
	display: flex;
	justify-content: space-between;
	.imgcon{
		width: 50px;
		height: 50px;
	}
}

.info_con{
	position: relative;
	z-index: 8;
	width: 316px;
	height: 231px;
	margin-top: -281px;
	margin-left: 284px;
	background: #000000;
	opacity: 0.8;
	color:#FFFFFF;
	font-weight: 400;
	padding:20px;
	.title{
		font-size: 18px;
		padding-bottom:20px;
	}
	.describe{
		font-size: 16px;
		padding-bottom: 10px;
		min-height: 80px;
	}
	.time{
		font-size: 12px;		
	}
	.navcon{
		display: flex;
		height:40px;
		align-items: center;
		.navsignle_cur,.navsignle{ 
			margin-right: 5px;
			height: 5px;
			background: #FFFFFF;
		}
		.navsignle_cur{
			width: 25px;
			border-radius:3px;
		}
		.navsignle{
			width: 5px;
			border-radius: 50%;
		}
	}
	
}

</style>
